import { render, staticRenderFns } from "./GenerationChart.vue?vue&type=template&id=c84f2b6e&lang=pug&"
import script from "./GenerationChart.vue?vue&type=script&lang=js&"
export * from "./GenerationChart.vue?vue&type=script&lang=js&"
import style0 from "./GenerationChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports